module.exports = __webpack_public_path__ + "images/john_s.jpg";